var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"admin"},[_c('div',{staticClass:"adminSideBar"},[_c('sidebar-menu',{class:{noSidebar : _vm.isSidebar}})],1),_c('div',{staticClass:"admin__main container-router"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }